import React, { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { Button } from 'primereact/button'
import { Toast } from 'primereact/toast'

import { useColumnToggle } from '../../../../../hooks/useColumnToggle'
import { ConfigurableTable } from '../../../../../utils/wrapper'
import { useConfigContext } from '../../../../ui-config'
import { useAllSuppliers } from '../../data'
import { SupplierUploadDialog } from './Upload/SupplierUploadDialog'

const STORAGE_KEY = 'selfservice-suppliers-visible-columns'
const TOGGLEABLE_FIELDS = [
  'Name',
  'Description',
  'Support',
  'DelForProcess.Completion',
  'OrderProcess.Completion',
]

type Props = {
  globalFilterValue: string
  setGlobalFilterValue: (value: string) => void
}

export const SupplierTable: React.FC<Props> = ({
  globalFilterValue,
  setGlobalFilterValue,
}) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { uiConfig: config } = useConfigContext()
  const { data: suppliers, isLoading } = useAllSuppliers()
  const { effectiveTableConfig, navigationColumnHeader } = useColumnToggle(
    config.selfservices.suppliers.table,
    TOGGLEABLE_FIELDS,
    STORAGE_KEY,
    true,
  )
  const [visible, setVisible] = useState(false)
  const name = 'suppliers'

  const toast = useRef<Toast>(null)

  const headerActions = (
    <>
      <Button
        label={t('suppliers.table.csv.label')}
        onClick={() => setVisible(true)}
        icon="pi pi-upload"
        outlined
      />

      <Button
        label={t('suppliers.table.add.label')}
        onClick={() => navigate(`/${name}/add`)}
        icon="pi pi-plus"
      />
    </>
  )

  const onHide = () => {
    setVisible(false)
  }

  return (
    <>
      <Toast ref={toast} />

      <ConfigurableTable
        config={effectiveTableConfig}
        data={suppliers}
        headerActions={headerActions}
        globalFilterFields={['Id', 'Name']}
        globalFilterValue={globalFilterValue}
        isLoading={isLoading}
        link={name}
        setGlobalFilterValue={setGlobalFilterValue}
        stateKey="table-suppliers"
        navigationColumnHeader={navigationColumnHeader}
      />
      <SupplierUploadDialog visible={visible} onHide={onHide} />
    </>
  )
}
